import EditAttachmentForm from './EditAttachmentForm'

export default EditAttachmentForm
